import React from "react";

const DescriptionVaccinationCamp = () => {
  return (
    <div className="vaccinationcamp-container">
      <div className="vaccinationcamp-hero">
        <h1 className="vaccinationcamp-subtitle">Need to arrange</h1>
        <h1 className="vaccinationcamp-title">
          <span className="pinkhighlig">vaccination camps</span> for your school, office, factory, or community?
        </h1>
      </div>

      <div className="vaccinationcamp-content">
        <p>
          With Dr Planete, you can easily post a request to invite doctors or hospitals for group vaccinations at your location.
        </p>

        <p><strong>Vaccinations help in:</strong></p>
        
          <li>Protecting people from serious diseases</li>
          <li>Preventing the spread of infections</li>
          <li>Creating a healthier and safer environment for all</li>
        

        <p><strong>You can organize camps for vaccines like:</strong></p>
        
          <li>Flu shots</li>
          <li>Hepatitis</li>
          <li>Typhoid</li>
          <li>And more, based on your need</li>
        

        <p><strong>How It Works:</strong></p>
        
          <p>Post your group vaccination request on Dr Planete.</p>
          <p>Doctors and hospitals who are members of our platform will be notified.</p>
          <p>Interested professionals will reach out to you directly if they’re available.</p>
        
      </div>
    </div>
  );
};

export default DescriptionVaccinationCamp;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .vaccinationcamp-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .vaccinationcamp-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .vaccinationcamp-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .vaccinationcamp-title {
    font-size: 40px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .vaccinationcamp-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .vaccinationcamp-content ul,
  .vaccinationcamp-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .vaccinationcamp-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .vaccinationcamp-title {
      font-size: 36px;
    }

    .vaccinationcamp-subtitle {
      font-size: 20px;
    }

    .vaccinationcamp-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
